import { FieldValues, useController, UseControllerProps } from 'react-hook-form'
import { CompactSelect, CompactSelectProps } from '../CompactSelect'

export type ControlledCompactSelectProps<T extends FieldValues> = UseControllerProps<T> & Partial<CompactSelectProps>

export function ControlledCompactSelect<T extends FieldValues>({
  control,
  name,
  rules,
  defaultValue,
  ...rest
}: ControlledCompactSelectProps<T>) {
  const { field, fieldState } = useController({
    control,
    name,
    rules,
    defaultValue,
  })

  return (
    <>
      <CompactSelect
        {...rest}
        {...field}
        value={String(field.value)}
        onChange={e => {
          field.onChange(e)
          rest.onChange?.(e)
        }}
      />
      {!!fieldState.error?.message && <span className={'text-red-500'}>{fieldState.error?.message}</span>}
    </>
  )
}
